import type React from 'react';
import classNames from '../../../../../utils/classNames';

export const DEVICE_STATUS_DOT_CLASSES = {
    online: 'bg-notification-success',
    offline: 'bg-notification-error',
    inactive: 'bg-gray-300',
} as const;

const SIZE_CLASSES = {
    small: 'h-2.5 w-2.5',
    medium: 'h-4 w-4',
} as const;

export function StatusDot({
    colorClassName,
    size = 'medium',
}: {
    colorClassName: string;
    size?: keyof typeof SIZE_CLASSES;
}): React.ReactElement {
    return (
        <span
            className={classNames(
                'inline-block shrink-0 rounded-full',
                SIZE_CLASSES[size],
                colorClassName
            )}
            aria-hidden
        />
    );
}
